import React, { useEffect } from 'react';
import { useEventTracking } from '../hooks/useAnalytics';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  const { trackEvent } = useEventTracking();

  useEffect(() => {
    trackEvent('privacy_policy_page_view', {
      page_title: 'Privacy Policy',
      page_location: '/privacy-policy',
      page_type: 'legal'
    });
  }, [trackEvent]);

  return (
    <main className="privacy-page">
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="main-content-container">
          <div className="privacy-hero-content">
            <h1 className="privacy-hero-title">Privacy Policy e Cookie Policy</h1>
            <p className="privacy-hero-subtitle">
              Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
            </p>
          </div>
        </div>
      </section>

      {/* Contenuto principale */}
      <section className="privacy-content-section">
        <div className="main-content-container">
          <div className="privacy-content">
            <h2>1. Titolare del trattamento</h2>
            <p><strong>Malianta S.r.l.</strong>, Via Bastione, 98057 Milazzo (ME) – Italia, P. IVA IT10412320961 – <a href="mailto:privacy@loverlist.com">privacy@loverlist.com</a> – PEC: malianta@pec.it</p>

            <h2>2. Tipologie di dati personali trattati</h2>
            <table>
            <thead><tr><th>Categoria di dati</th><th>Descrizione</th></tr></thead>
            <tbody>
            <tr><td>Dati di navigazione</td><td>IP, dispositivo, browser, pagine visitate, data/ora, referrer</td></tr>
            <tr><td>Dati di registrazione</td><td>Nome, cognome, e‑mail, password hash, azienda (venditori), partita IVA, telefono</td></tr>
            <tr><td>Dati transazioni pubblicitarie</td><td>Saldo wallet, ricariche, budget campagne, clic/impression</td></tr>
            <tr><td>Eventi di interazione</td><td>Visualizzazioni prodotto, wishlist, click‑out, log conversioni</td></tr>
            <tr><td>Cookie e tecnologie simili</td><td>ID di sessione, cookie tecnici, analytics, preferenze</td></tr>
            </tbody>
            </table>

            <h2>3. Finalità e basi giuridiche</h2>
            <table>
            <thead><tr><th>#</th><th>Finalità</th><th>Base giuridica</th><th>Dettagli</th></tr></thead>
            <tbody>
            <tr><td>3.1</td><td>Erogazione servizi, account, wallet</td><td>Contratto (art. 6 b)</td><td>Dati di registrazione e transazioni</td></tr>
            <tr><td>3.2</td><td>Analisi statistica (GA4 + analytics interno)</td><td>Legittimo interesse (art. 6 f)</td><td>Pseudonimi, IP anonimizzati</td></tr>
            <tr><td>3.3</td><td>Newsletter e comunicazioni</td><td>Consenso (art. 6 a)</td><td>Opt‑in, disiscrizione</td></tr>
            <tr><td>3.4</td><td>Obblighi legali</td><td>Legge (art. 6 c)</td><td>Fiscale, contabile, sicurezza</td></tr>
            <tr><td>3.5</td><td>Prevenzione abusi/frodi</td><td>Legittimo interesse (art. 6 f)</td><td>Log monitoraggio</td></tr>
            </tbody>
            </table>

            <h2>4. Conservazione dei dati</h2>
            <table>
            <thead><tr><th>Dato</th><th>Periodo</th></tr></thead>
            <tbody>
            <tr><td>Dati account</td><td>Durata rapporto + 10 anni</td></tr>
            <tr><td>Log sicurezza</td><td>12 mesi</td></tr>
            <tr><td>Dati analytics pseudonimizzati</td><td>26 mesi (GA4) / 24 mesi (interno)</td></tr>
            <tr><td>Liste opt‑out</td><td>Indeterminato</td></tr>
            </tbody>
            </table>

            <h2>5. Destinatari</h2>
            <ul>
            <li>Fornitori IT (hosting, manutenzione, email)</li>
            <li>Google LLC (GA4) – Clausole Contrattuali Standard</li>
            <li>Provider di pagamento (ricariche wallet)</li>
            <li>Autorità pubbliche su richiesta</li>
            </ul>

            <h2>6. Trasferimenti extra‑UE</h2>
            <p>Dati GA4 possono essere trasferiti negli USA secondo Clausole Contrattuali Standard e misure supplementari (IP anonimizzato, aggregazione).</p>

            <h2>7. Diritti dell’interessato</h2>
            <p>Accesso, rettifica, cancellazione, limitazione, opposizione, portabilità, revoca consenso via <a href="mailto:privacy@loverlist.com">privacy@loverlist.com</a>. Reclamo al Garante.</p>

            <h2>8. Cookie Policy</h2>
            <h3>8.1 Cosa sono i cookie?</h3>
            <p>Piccoli file di testo inviati dai siti al dispositivo dell’utente.</p>

            <h3>8.2 Tipologie di cookie utilizzate</h3>
            <table>
            <thead><tr><th>Tipo</th><th>Descrizione</th><th>Durata</th></tr></thead>
            <tbody>
            <tr><td>Tecnici</td><td>Funzionamento essenziale del sito</td><td>Sessione / 12 mesi</td></tr>
            <tr><td>Analytics 1ª parte</td><td>Sistema interno pseudonimo</td><td>24 mesi</td></tr>
            <tr><td>Analytics 3ª parte (GA4)</td><td>IP anonimizzato, statistiche aggregate</td><td>26 mesi</td></tr>
            <tr><td>Marketing</td><td>Remarketing Google/Meta (previo consenso)</td><td>Fino a 12 mesi</td></tr>
            </tbody>
            </table>

            <h3>8.3 Gestione dei cookie</h3>
            <p>Cookie banner con opzioni: accetta, rifiuta, personalizza. Preferenze modificabili via link “Impostazioni cookie”.</p>

            <h3>8.4 Disattivazione via browser</h3>
            <p>Impostazioni di Chrome, Firefox, Edge, Safari. Disabilitare cookie tecnici può limitare funzionalità.</p>

            <h2>9. Sistema di analytics interno</h2>
            <p>Eventi tracciati in forma pseudonima, server UE, accesso limitato.</p>

            <h2>10. Modifiche</h2>
            <p>Eventuali aggiornamenti saranno pubblicati su loverlist.com/privacy e, se sostanziali, notificati via banner o email.</p>
   
          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicyPage; 